import React, { useEffect, useState } from 'react';
import { IframeInjector } from '../../vanillaComponent/xrm-lead-gen.ts';
import CodeEditor from 'sharedComponents/editor/index.tsx';

import { debounce } from 'lodash';
import { json } from 'stream/consumers';
import GistViewer from 'sharedComponents/editor/index.tsx';

function XRMLeadGenWidget() {
  const [iframeInjector, setIframeInjector] = useState(`
    new IframeInjector(
      'search-container',
      'https://d18cjm93x7men9.cloudfront.net/?isOtpVisible=false&primaryColor=%238b0000&gtm_id=GTM-12345&lead_source=12345',
      '100%',
      '600px'
    )`);

  useEffect(() => {
    new IframeInjector(
      'search-container',
      'https://d18cjm93x7men9.cloudfront.net/?isOtpVisible=false&primaryColor=%238b0000&gtm_id=GTM-123456&lead_source=12345',
      '100%',
      '600px'
    );
  }, []);

  // const debouncedHandleCodeChange = debounce(async (searchText: string) => {
  //   handleCodeChange(searchText);
  // }, 600);

  // const handleCodeChange = (newCode: any) => {
  //   try {
  //     console.log('newCode', newCode);

  //     const match = newCode.match(/new IframeInjector\(([^)]+)\)/);
  //     const parametersString = match ? match[1] : '';

  //     console.log('parametersString', parametersString[1]);
  //     // Parse the parameters as JSON
  //     const parameters = JSON.parse(`[${parametersString}]`);

  //     // Now, 'parameters' is an array containing the constructor parameters
  //     console.log('parameters', parameters);

  //     const searchContainer = document.getElementById('search-container');

  //     // // Check if the search-container element exists
  //     if (searchContainer) {
  //       // Remove any existing iframe inside search-container
  //       const existingIframe = searchContainer.querySelector('iframe');
  //       if (existingIframe) {
  //         existingIframe.parentNode.removeChild(existingIframe);
  //       }

  //       // new IframeInjector(newCode);
  //       // const newIframeInjector = `${newCode}`;

  //       // console.log('newIframeInjector', newIframeInjector);
  //     }
  //   } catch (error) {
  //     console.error('Error updating IframeInjector:', error);
  //   }
  // };
  // const gistId = '815feb8a305ad959fac68a5f2aaa36de';

  return (
    <>
      {/* <CodeEditor initialCode={iframeInjector} onChange={debouncedHandleCodeChange} />*/}

      {/* <h1>Gist Viewer</h1> */}

      <div id='search-container' />

      <iframe
        title='Example HTML'
        src='/htmlPages/lead_gen.html'
        style={{ paddingTop: '50px', border: 'none' }}
        width='100%'
        height='630px'
      ></iframe>
    </>
  );
}

export default XRMLeadGenWidget;
